import { onAuthStateChanged } from "firebase/auth";

const AuthStateChange = (auth,setAuthenticated,setUserExists) => {

    onAuthStateChanged(auth, (user) => {
        if (user) {
          setAuthenticated(true);
          setUserExists(true);
        } else {
          // User is signed out
          // ...
          setAuthenticated(false);
          setUserExists(false);
        }
      });

}

export default AuthStateChange;